import React, { useState, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import PlaceHolder from './PlaceHolder'
import ImageIcon from '../icons/image.svg'

import SettingsContext from '../components/SettingsContext'
import { setInfoPanel } from '../slices/ui'


const InfoPanelContent = (props) => {
  const { title, subtitle, images, summary, extra, children } = props 
  const image = images && images[0]

  return (
    <>
      <div className="pwa__infopanel__inner">

        { image && image.small && <img className="pwa__infopanel__image fade-in delay" src={ image.small } />}

        { image && image.attribution_url && (
          <a href={image.attribution_url}
            className="pwa__infopanel__image__link  button raised circular fade-in delay"
            target="_new"
            rel="noopener">
            <ImageIcon />
          </a>
        )}

        <div className="pwa__infopanel__header fade-in">

          <h3>
            <span className="pwa__infopanel__title fade-in delay">
              <PlaceHolder value={title}/>
            </span>
            <span className="pwa__infopanel__subtitle fade-in delay">
              <PlaceHolder value={subtitle}/>
            </span>
          </h3>

          { summary && (
              <div className="pwa__infopanel__details fade-in delay">
                  {summary}
              </div>
          )}

        </div>

        { children }

      </div>
    </>
  )
}

export default InfoPanelContent
